import { StyledPageWrapper } from "@/pages/integrations/shared/integrations.styles";
import { IntegrationsZapierPageContent } from "@/pages/integrations/zapier/integrations-zapier-page-content";
import { IntegrationsPageHeader } from "@/pages/integrations/integrations-page-header";
import { useAppStore } from "@/store";
import { observer } from "mobx-react-lite";
import { FC, useEffect, useState } from "react";

interface IntegrationsZapierPageProps {}

export const IntegrationsZapierPage: FC<IntegrationsZapierPageProps> = observer(() => {
  const { store } = useAppStore();
  const [ready, setReady] = useState(false);
  const { isReady } = store.zapierIntegration;

  useEffect(() => {
    if (isReady) {
      setTimeout(() => {
        setReady(true);
      }, 100);
    }
  }, [isReady]);

  return (
    <StyledPageWrapper visible={ready}>
      <IntegrationsPageHeader />
      <IntegrationsZapierPageContent />
    </StyledPageWrapper>
  );
});
